import React, { useEffect, useState } from 'react';
import './CardsCantidad.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faUsers, faImage, faBook, faTachometerAlt, faCode } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import baseURL from '../../url';
export default function CardsCantidad() {
    const [empleados, setEmpleados] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [asistencias, setAsistencias] = useState([]);


    useEffect(() => {
        cargarEmpleados();
        cargarUsuarios();
        cargarAsistencias();
    }, []);

    const cargarEmpleados = () => {
        fetch(`${baseURL}/empleadosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setEmpleados(data.empleados || []);
            })
            .catch(error => console.error('Error al cargar empleados:', error));
    };


    const cargarUsuarios = () => {
        fetch(`${baseURL}/usuariosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setUsuarios(data.usuarios || []);
            })
            .catch(error => console.error('Error al cargar usuarios:', error));
    };

    const cargarAsistencias = () => {
        fetch(`${baseURL}/asistenciaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setAsistencias(data.asistencias || []);
                console.log(data.asistencias)
            })
            .catch(error => console.error('Error al cargar asistencias:', error));
    };




    return (
        <div className='CardsCantidad'>

            <Anchor to={`/dashboard/usuarios`} className='cardCantidad'>
                <FontAwesomeIcon icon={faUser} className='icons' />
                <div className='deColumn'>

                    <h3>Usuarios</h3>
                    <h2>{usuarios.length}</h2>
                </div>

            </Anchor>
            <Anchor to={`/dashboard/empleados`} className='cardCantidad' >
                <FontAwesomeIcon icon={faUsers} className='icons' />
                <div className='deColumn'>

                    <h3>Empleados</h3>
                    <h2>{empleados.length}</h2>
                </div>

            </Anchor>
            <Anchor to={`/dashboard/asistencias`} className='cardCantidad' >
                <FontAwesomeIcon icon={faBook} className='icons' />
                <div className='deColumn'>

                    <h3>Asistencias</h3>
                    <h2>{asistencias.length}</h2>
                </div>

            </Anchor>



        </div>
    )
}
